export default "__VITE_ASSET__7e88c02a__"